"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueNotAvailableError = void 0;
class ValueNotAvailableError extends Error {
    constructor() {
        super("ValueNotAvailableError");
    }
}
exports.ValueNotAvailableError = ValueNotAvailableError;
//# sourceMappingURL=ValueNotAvailableError.js.map